import React, { createContext, PropsWithChildren, useContext, JSX } from 'react';
import { ExternalPackageSearchParams } from './PackageSearchParams';

export type ExternalSearchParamsContextProps = {
  mode: 'LOCAL' | 'TEST' | 'PROD' | 'INTTEST' | 'INTPROD';
  triggerSearch?: boolean;
  widgetSessionKeyPrefix?: string;
} & Partial<ExternalPackageSearchParams>;

export const ExternalSearchParamsContext = createContext<ExternalSearchParamsContextProps | null>(
  null
);

export const useExternalSearchParams = (): ExternalSearchParamsContextProps | null => {
  return useContext<ExternalSearchParamsContextProps | null>(ExternalSearchParamsContext);
};

const ExternalSearchParams = (
  props: PropsWithChildren<ExternalSearchParamsContextProps>
): JSX.Element => {
  const { children, ...rest } = props;

  return (
    <ExternalSearchParamsContext.Provider value={rest}>
      {children}
    </ExternalSearchParamsContext.Provider>
  );
};

export default ExternalSearchParams;
